import { WorkoutsRepository } from "../../infra/repository/workout.repository";
import { Workout } from "../domain/workout";

export class GetWorkoutUseCase {
    static async execute(workoutId: string): Promise<Workout> {
        try {
            const response = await WorkoutsRepository.getByWorkout(workoutId);
            if (response.error) throw Error("Erro ao buscar treino");
            return response.data;
        } catch (error) {
            throw Error("Erro ao buscar treino");
        }
    }
}
